import { NgModule } from '@angular/core';
import { AndroidPermissions } from '@awesome-cordova-plugins/android-permissions/ngx';
import { AppPreferences } from '@awesome-cordova-plugins/app-preferences/ngx';
import { Camera } from '@awesome-cordova-plugins/camera/ngx';
import { Device } from '@awesome-cordova-plugins/device/ngx';
import { FileOpener } from '@awesome-cordova-plugins/file-opener/ngx';
import { File } from '@awesome-cordova-plugins/file/ngx';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
import { NativeStorage } from '@awesome-cordova-plugins/native-storage/ngx';
import { Vibration } from '@awesome-cordova-plugins/vibration/ngx';
import { Zip } from '@awesome-cordova-plugins/zip/ngx';

@NgModule({
  providers: [Device, AppPreferences, AndroidPermissions, File, Vibration, Geolocation, FileOpener, Camera, NativeStorage, Zip]
})
export class NgxImports {}
